import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['isAdmin', 'isSectorManager'])
  },
  filters: {
    dotClass (value) {
      const COLORS = {
        'available': 'has-bg-disponible',
        'approved': 'has-bg-success',
        'pending': 'has-bg-info',
        'optioned': 'has-bg-optionne',
        'sold': 'has-bg-acte',
        'refused': 'has-bg-danger',
        'draft': 'has-bg-draft',
        'expired': 'has-bg-draft',
        'canceled_by_admin': 'has-bg-draft',
        'canceled_by_seller': 'has-bg-draft',
        'reserved': 'has-bg-reserve',
        'waiting_list': 'has-bg-warning'
      }
      return COLORS[value]
    }
  },
  methods: {
    statusColor (status) {
      const COLORS = {
        'approved': ['is-status-success', 'is-success'],
        'canceled_by_admin': ['is-status-draft', 'is-draft'],
        'canceled_by_seller': ['is-status-draft', 'is-draft'],
        'expired': ['is-status-draft', 'is-draft'],
        'pending': ['is-status-info', 'is-info'],
        'refused': ['is-status-danger', 'is-danger'],
        'sold': ['is-status-acte', 'is-acte'],
        'reserved': ['is-status-reserve', 'is-reserve'],
        'optioned': ['is-status-optionne', 'is-optionne'],
        'waiting_list': ['is-status-warning', 'is-warning']
      }
      return COLORS[status]
    },
    isInRunningStatus (status) {
      const okStatus = ['approved', 'waiting_list', 'pending']
      return okStatus.includes(status)
    },
    canUpgrade (status) {
      const okStatus = ['approved', 'waiting_list']
      return (this.isAdmin || this.isSectorManager) && okStatus.includes(status)
    },
    canCancel (status) {
      let okStatus
      if (this.isAdmin || this.isSectorManager) {
        okStatus = ['approved', 'waiting_list']
      } else {
        okStatus = ['approved', 'pending']
      }
      return okStatus.includes(status)
    },
    canChangeStatus (status) {
      return this.isAdmin || this.isSectorManager
    },
    canApprove (status) {
      return (this.isAdmin || this.isSectorManager) && status === 'pending'
    },
    canRefuse (status) {
      return (this.isAdmin || this.isSectorManager) && status === 'pending'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/OptionStatusMixin.js